import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';
import { NavMenuNotLoggedIn } from './NavMenuNotLoggedIn';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ScrollContext } from "./ScrollContext";

export class Layout extends Component {
  static displayName = Layout.name;

  // Use the contextType static property to access the context value
  static contextType = ScrollContext;

  handleScroll = (e) => {
    let bottom = Math.abs(e.target.scrollingElement.scrollHeight - e.target.scrollingElement.clientHeight - e.target.scrollingElement.scrollTop) < 200; //Should be < 1 instead of < 100 but not working on some devices
    // Use the setIsBottom function from the context value to update the state
    this.context.setIsBottom(bottom);
    this.context.setScrollPosition(e.target.scrollingElement.scrollTop);
  }

  // Add the scroll event listener when the component mounts
  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  // Remove the scroll event listener when the component unmounts
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  render() {
    if (localStorage.getItem('userId') === null) {
      return (
        <div>
          <NavMenuNotLoggedIn />
          <ToastContainer />
          <Container>{this.props.children}</Container>
        </div>
      );
    }
    return (
      <div onScroll={this.handleScroll}>
        <NavMenu />
        <ToastContainer />
        <Container>{this.props.children}</Container>
      </div>
    );
  }
}
